/* eslint-disable max-len */
// Metadata de las notificaciones de email editables desde el dashboard.
// Los defaults y placeholders deben mantenerse en sync con
// functions/emails/templates.js y functions/emails/customizer.js.

const BRAND = {
  name: 'B&B Target Center',
  tagline: 'Polígono de Tiro · San Juan, PR',
  primary: '#d40100',
  primaryDark: '#a30000',
  text: '#1a1a1a',
  muted: '#637381',
  bg: '#F4F6F8',
  cardBg: '#FFFFFF',
  border: '#E0E4EA',
  success: '#22C55E',
  danger: '#FF5630',
  logoUrl: 'https://bbtargetcenter.com/wp-content/uploads/2020/03/53201072_2501641786530857_5217031044271702016_o-1-1-uai-258x258.png',
  websiteUrl: 'https://bbtargetcenterpr.com',
  supportEmail: 'info@bbtargetcenterpr.com',
  address: '369 San Claudio Ave #3, San Juan, PR 00926',
};

// ----- Réplica del layout del backend para vista previa -----

function badge(label, color) {
  return `<span style="display:inline-block;background:${color}1a;color:${color};padding:6px 12px;border-radius:999px;font-size:12px;font-weight:700;letter-spacing:0.3px;">${label}</span>`;
}

function infoBox(text, color = BRAND.primary) {
  return `
    <div style="background:${color}0d;border-left:4px solid ${color};padding:14px 18px;border-radius:8px;margin:18px 0;">
      <p style="margin:0;font-size:14px;line-height:1.5;color:${BRAND.text};">${text}</p>
    </div>
  `;
}

function detailsTable(rows) {
  return `
    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="border-collapse:separate;border-spacing:0;border:1px solid ${BRAND.border};border-radius:12px;overflow:hidden;">
      ${rows.map((r, i) => `
        <tr>
          <td style="padding:14px 18px;background-color:${i % 2 === 0 ? '#FAFBFC' : '#FFFFFF'};border-bottom:${i === rows.length - 1 ? '0' : `1px solid ${BRAND.border}`};font-size:13px;color:${BRAND.muted};font-weight:500;width:40%;vertical-align:top;">
            ${r.label}
          </td>
          <td style="padding:14px 18px;background-color:${i % 2 === 0 ? '#FAFBFC' : '#FFFFFF'};border-bottom:${i === rows.length - 1 ? '0' : `1px solid ${BRAND.border}`};font-size:14px;color:${BRAND.text};font-weight:600;text-align:right;">
            ${r.value}
          </td>
        </tr>
      `).join('')}
    </table>
  `;
}

function layout({ title, intro, contentHtml, footerNote }) {
  return `<!DOCTYPE html>
<html lang="es">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
<title>${title}</title>
</head>
<body style="margin:0;padding:0;background-color:${BRAND.bg};font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;color:${BRAND.text};">
  <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color:${BRAND.bg};">
    <tr>
      <td align="center" style="padding:40px 16px;">
        <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="600" style="max-width:600px;width:100%;">
          <tr>
            <td align="center" style="padding-bottom:24px;">
              <img src="${BRAND.logoUrl}" alt="B&amp;B Target Center" width="80" height="80" style="display:block;border:0;border-radius:16px;width:80px;height:80px;" />
            </td>
          </tr>
          <tr>
            <td style="background-color:${BRAND.cardBg};border-radius:16px;border:1px solid ${BRAND.border};overflow:hidden;">
              <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                <tr>
                  <td style="background:linear-gradient(135deg, ${BRAND.primary} 0%, ${BRAND.primaryDark} 100%);padding:32px 32px 28px 32px;color:#FFF;">
                    <h1 style="margin:0;font-size:24px;font-weight:700;line-height:1.2;color:#FFF;">${title}</h1>
                    ${intro ? `<p style="margin:12px 0 0 0;font-size:15px;line-height:1.5;color:rgba(255,255,255,0.92);">${intro}</p>` : ''}
                  </td>
                </tr>
              </table>
              <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                <tr>
                  <td style="padding:28px 32px 8px 32px;">${contentHtml}</td>
                </tr>
              </table>
              ${footerNote ? `
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                  <tr>
                    <td style="padding:16px 32px 28px 32px;">
                      <p style="margin:0;font-size:13px;line-height:1.5;color:${BRAND.muted};">${footerNote}</p>
                    </td>
                  </tr>
                </table>
              ` : ''}
            </td>
          </tr>
          <tr>
            <td align="center" style="padding:24px 16px 8px 16px;">
              <p style="margin:0;font-size:12px;color:${BRAND.muted};line-height:1.6;">
                ${BRAND.address}<br/>
                ¿Preguntas? Escríbenos a <a href="mailto:${BRAND.supportEmail}" style="color:${BRAND.primary};text-decoration:none;">${BRAND.supportEmail}</a>
              </p>
              <p style="margin:8px 0 0 0;font-size:11px;color:${BRAND.muted};">© ${new Date().getFullYear()} ${BRAND.name}. ${BRAND.tagline}.</p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`;
}

// ----- Valores de ejemplo para la vista previa -----

const SAMPLE_VALUES = {
  waitlistAvailable: {
    '%customer_name%': 'Juan Pérez', '%customer_first_name%': 'Juan', '%product_name%': 'Glock 19 Gen5 · 9mm', '%message%': 'Lo tenemos en $599 + IVU.',
    '%details_table%': detailsTable([{ label: 'Producto', value: 'Glock 19 Gen5 · 9mm' }]),
  },
  transferRequestReceived: {
    '%customer_name%': 'Juan Pérez', '%customer_first_name%': 'Juan', '%code%': 'T-ABC123', '%direction%': 'B&B recibe el arma de Kissimmee Guns LLC', '%firearms%': 'Sig Sauer P365 (9mm) · Serie ABC123', '%dealer_name%': 'Kissimmee Guns LLC', '%fee%': '$125.00', '%carrier%': '', '%tracking_number%': '', '%message%': '', '%signature_name%': 'Juan Pérez', '%signed_date%': '20/10/2026',
    '%status_badge%': badge('SOLICITUD RECIBIDA', BRAND.primary),
    '%details_table%': detailsTable([{ label: 'Referencia', value: 'T-ABC123' }, { label: 'Tipo', value: 'B&B recibe el arma de Kissimmee Guns LLC' }, { label: 'Arma(s)', value: 'Sig Sauer P365 (9mm) · Serie ABC123' }, { label: 'Armería', value: 'Kissimmee Guns LLC' }, { label: 'Costo del servicio', value: '$125.00' }]),
  },
  transferShipped: {
    '%customer_name%': 'Juan Pérez', '%customer_first_name%': 'Juan', '%code%': 'T-ABC123', '%direction%': 'B&B envía el arma a Kissimmee Guns LLC', '%firearms%': 'Sig Sauer P365 (9mm) · Serie ABC123', '%dealer_name%': 'Kissimmee Guns LLC', '%fee%': '$125.00', '%carrier%': 'USPS', '%tracking_number%': '9400 1118 9922 3344 5566 77', '%message%': '', '%signature_name%': '', '%signed_date%': '',
    '%status_badge%': badge('ENVIADA', BRAND.success),
    '%details_table%': detailsTable([{ label: 'USPS', value: '9400 1118 9922 3344 5566 77' }, { label: 'Referencia', value: 'T-ABC123' }, { label: 'Arma(s)', value: 'Sig Sauer P365 (9mm) · Serie ABC123' }, { label: 'Armería', value: 'Kissimmee Guns LLC' }]),
  },
  transferReceived: {
    '%customer_name%': 'Juan Pérez', '%customer_first_name%': 'Juan', '%code%': 'T-ABC123', '%direction%': 'B&B recibe el arma de Kissimmee Guns LLC', '%firearms%': 'Sig Sauer P365 (9mm) · Serie ABC123', '%dealer_name%': 'Kissimmee Guns LLC', '%fee%': '$125.00', '%carrier%': '', '%tracking_number%': '', '%message%': '', '%signature_name%': '', '%signed_date%': '',
    '%status_badge%': badge('LISTA PARA RECOGER', BRAND.success),
    '%details_table%': detailsTable([{ label: 'Referencia', value: 'T-ABC123' }, { label: 'Arma(s)', value: 'Sig Sauer P365 (9mm) · Serie ABC123' }, { label: 'Armería', value: 'Kissimmee Guns LLC' }, { label: 'Costo del servicio', value: '$125.00' }]),
  },
  serviceOrderArrived: {
    '%customer_name%': 'Juan Pérez', '%customer_first_name%': 'Juan', '%code%': 'P-ABC123', '%items%': '2 × Cargador Glock 19 (15 rds)', '%balance%': '$0.00', '%message%': '', '%service_type%': 'pedido especial',
    '%status_badge%': badge('LISTO PARA RECOGER', BRAND.success),
    '%details_table%': detailsTable([{ label: 'Referencia', value: 'P-ABC123' }, { label: 'Artículos', value: '2 × Cargador Glock 19 (15 rds)' }]),
  },
  serviceReady: {
    '%customer_name%': 'Juan Pérez', '%customer_first_name%': 'Juan', '%code%': 'L-ABC123', '%items%': 'Glock 19 · Serie ABC123', '%balance%': '$45.00', '%message%': '', '%service_type%': 'limpieza',
    '%status_badge%': badge('LISTO PARA RECOGER', BRAND.success),
    '%details_table%': detailsTable([{ label: 'Referencia', value: 'L-ABC123' }, { label: 'Arma', value: 'Glock 19 · Serie ABC123' }, { label: 'Balance pendiente', value: '$45.00' }]),
  },
  reservationPaymentLink: {
    '%customer_name%': 'Juan Pérez',
    '%customer_first_name%': 'Juan',
    '%category_name%': 'Curso Privado',
    '%date%': 'Lunes, 10 de Agosto 2026',
    '%start_time%': '2:00 PM',
    '%end_time%': '4:00 PM',
    '%lane_name%': '',
    '%confirmation_code%': 'BBTC-1234',
    '%amount%': '$167.25',
    '%payment_url%': 'https://bbtc-dashboard.web.app/pay?t=ejemplo',
    '%pay_button%': `<div style="text-align:center;margin:20px 0;"><a href="#" style="display:inline-block;background:${BRAND.primary};padding:14px 28px;color:#FFF;text-decoration:none;font-weight:600;font-size:15px;border-radius:10px;">Pagar $167.25</a></div>`,
    '%status_badge%': badge('PENDIENTE DE PAGO', '#FFAB00'),
    '%details_table%': detailsTable([
      { label: 'Curso', value: 'Curso Privado' },
      { label: 'Fecha', value: 'Lunes, 10 de Agosto 2026' },
      { label: 'Hora', value: '2:00 PM – 4:00 PM' },
      { label: 'Código', value: 'BBTC-1234' },
      { label: 'Total a pagar', value: '<span style="color:#FF5630;font-weight:700;">$167.25</span>' },
    ]),
    '%info_box%': infoBox('Tu inscripción al curso queda reservada en cuanto completes el pago. Si no se paga antes de la fecha, el cupo se libera.', '#FFAB00'),
  },
  reservationConfirmation: {
    '%customer_name%': 'Juan Pérez',
    '%customer_first_name%': 'Juan',
    '%category_name%': 'Reservación de Lane',
    '%date%': 'Lunes, 10 de Agosto 2026',
    '%start_time%': '2:00 PM',
    '%end_time%': '3:00 PM',
    '%lane_name%': 'Lane 3',
    '%confirmation_code%': 'BBTC-1234',
    '%amount%': '$45.00',
    '%status_badge%': badge('CONFIRMADA', BRAND.success),
    '%details_table%': detailsTable([
      { label: 'Categoría', value: 'Reservación de Lane' },
      { label: 'Fecha', value: 'Lunes, 10 de Agosto 2026' },
      { label: 'Hora', value: '2:00 PM – 3:00 PM' },
      { label: 'Lane', value: 'Lane 3' },
      { label: 'Código de confirmación', value: '<span style="font-family:Menlo,monospace;background:#F4F6F8;padding:4px 10px;border-radius:6px;letter-spacing:1px;">BBTC-1234</span>' },
      { label: 'Total pagado', value: '$45.00' },
    ]),
    '%deposit_banner%': '',
    '%info_box%': infoBox('Llega 10 minutos antes de tu hora. Trae tu identificación y, si aplica, tu licencia de armas.'),
  },
  reservationCancellation: {
    '%customer_name%': 'Juan Pérez',
    '%customer_first_name%': 'Juan',
    '%category_name%': 'Reservación de Lane',
    '%date%': 'Lunes, 10 de Agosto 2026',
    '%start_time%': '2:00 PM',
    '%end_time%': '3:00 PM',
    '%lane_name%': 'Lane 3',
    '%confirmation_code%': 'BBTC-1234',
    '%reason%': 'Solicitado por el cliente',
    '%refund_amount%': '$45.00',
    '%status_badge%': badge('CANCELADA', BRAND.danger),
    '%details_table%': detailsTable([
      { label: 'Categoría', value: 'Reservación de Lane' },
      { label: 'Fecha', value: 'Lunes, 10 de Agosto 2026' },
      { label: 'Hora', value: '2:00 PM – 3:00 PM' },
      { label: 'Lane', value: 'Lane 3' },
      { label: 'Motivo', value: 'Solicitado por el cliente' },
      { label: 'Reembolso', value: '$45.00' },
    ]),
    '%refund_box%': infoBox('Tu reembolso de $45.00 se procesará a tu método de pago original en 5–10 días hábiles.', BRAND.success),
  },
  welcomeEmail: {
    '%customer_name%': 'Juan Pérez',
    '%customer_first_name%': 'Juan',
    '%details_table%': detailsTable([
      { label: 'Nombre', value: 'Juan Pérez' },
      { label: 'Estado de cuenta', value: badge('CREADA', BRAND.success) },
    ]),
  },
  layawayPaymentReceived: {
    '%customer_name%': 'Juan Pérez',
    '%customer_first_name%': 'Juan',
    '%firearm%': 'Glock 19 Gen5 (9mm)',
    '%serial_number%': 'ABC1234',
    '%concept%': 'Abono',
    '%amount%': '$100.00',
    '%price%': '$650.00',
    '%paid%': '$425.00',
    '%balance%': '$225.00',
    '%due_date%': 'Lunes, 2 de Febrero 2027',
    '%status_badge%': badge('LAYAWAY ACTIVO', BRAND.primary),
    '%details_table%': detailsTable([
      { label: 'Arma', value: 'Glock 19 Gen5 (9mm)' },
      { label: 'Núm. de serie', value: 'ABC1234' },
      { label: 'Concepto', value: 'Abono' },
      { label: 'Total pagado', value: '$100.00' },
      { label: 'Precio del arma', value: '$650.00' },
      { label: 'Pagado a la fecha', value: '$425.00' },
      { label: 'Balance pendiente', value: '$225.00' },
      { label: 'Fecha límite', value: 'Lunes, 2 de Febrero 2027' },
    ]),
  },
  layawayDueReminder: {
    '%customer_name%': 'Juan Pérez',
    '%customer_first_name%': 'Juan',
    '%firearm%': 'Glock 19 Gen5 (9mm)',
    '%serial_number%': 'ABC1234',
    '%balance%': '$225.00',
    '%due_date%': 'Lunes, 2 de Febrero 2027',
    '%days_left%': '7',
    '%storage_fee%': '$20.00',
    '%status_badge%': badge('VENCE PRONTO', '#FFAB00'),
    '%details_table%': detailsTable([
      { label: 'Arma', value: 'Glock 19 Gen5 (9mm)' },
      { label: 'Balance pendiente', value: '$225.00' },
      { label: 'Fecha límite', value: 'Lunes, 2 de Febrero 2027' },
      { label: 'Días restantes', value: '7' },
    ]),
  },
  layawayPaymentToStaff: {
    '%customer_name%': 'Juan Pérez',
    '%customer_phone%': '787-555-1234',
    '%customer_email%': 'juan@example.com',
    '%firearm%': 'Glock 19 Gen5 (9mm)',
    '%serial_number%': 'ABC1234',
    '%concept%': 'Abono',
    '%amount%': '$100.00',
    '%balance%': '$225.00',
    '%due_date%': 'Lunes, 2 de Febrero 2027',
    '%details_table%': detailsTable([
      { label: 'Cliente', value: 'Juan Pérez' },
      { label: 'Teléfono', value: '787-555-1234' },
      { label: 'Arma', value: 'Glock 19 Gen5 (9mm)' },
      { label: 'Concepto', value: 'Abono' },
      { label: 'Monto', value: '$100.00' },
      { label: 'Balance', value: '$225.00' },
    ]),
  },
  membershipPaymentReceived: {
    '%customer_name%': 'Juan Pérez',
    '%customer_first_name%': 'Juan',
    '%plan_name%': 'Membresía Anual',
    '%amount%': '$250.00',
    '%expiration_date%': 'Sábado, 10 de Agosto 2027',
    '%status_badge%': badge('MEMBRESÍA ACTIVA', BRAND.success),
    '%details_table%': detailsTable([
      { label: 'Plan', value: 'Membresía Anual' },
      { label: 'Monto pagado', value: '$250.00' },
      { label: 'Vence', value: 'Sábado, 10 de Agosto 2027' },
    ]),
  },
  paymentNotificationToStaff: {
    '%customer_name%': 'Juan Pérez',
    '%customer_email%': 'juan@example.com',
    '%plan_name%': 'Membresía Anual',
    '%amount%': '$250.00',
    '%payment_date%': '10/8/2026, 2:15:00 PM',
    '%details_table%': detailsTable([
      { label: 'Cliente', value: 'Juan Pérez' },
      { label: 'Email', value: 'juan@example.com' },
      { label: 'Plan', value: 'Membresía Anual' },
      { label: 'Monto', value: '$250.00' },
      { label: 'Fecha', value: '10/8/2026, 2:15:00 PM' },
    ]),
  },
  licenseExpirationReminder: {
    '%customer_name%': 'Juan Pérez',
    '%customer_first_name%': 'Juan',
    '%license_number%': 'LIC-2024-4567',
    '%expiration_date%': 'Lunes, 5 de Octubre 2026',
    '%days_left%': '60',
    '%status_badge%': badge('POR VENCER', '#FFAB00'),
    '%details_table%': detailsTable([
      { label: 'Número de licencia', value: 'LIC-2024-4567' },
      { label: 'Fecha de vencimiento', value: 'Lunes, 5 de Octubre 2026' },
      { label: 'Días restantes', value: '<span style="color:#FFAB00;font-weight:700;">60 días</span>' },
    ]),
  },
  membershipExpirationReminder: {
    '%customer_name%': 'Juan Pérez',
    '%customer_first_name%': 'Juan',
    '%expiration_date%': 'Lunes, 5 de Octubre 2026',
    '%days_left%': '60',
    '%status_badge%': badge('POR VENCER', '#FFAB00'),
    '%details_table%': detailsTable([
      { label: 'Fecha de vencimiento', value: 'Lunes, 5 de Octubre 2026' },
      { label: 'Días restantes', value: '<span style="color:#FFAB00;font-weight:700;">60 días</span>' },
    ]),
  },
};

// ----- Definición de cada notificación -----

export const EMAIL_TEMPLATES = [
  {
    key: 'waitlistAvailable',
    name: 'Lista de espera: producto disponible',
    description: 'Se envía al cliente cuando el staff marca que llegó un producto de la lista de espera (Dashboard → Lista de espera → Avisar que llegó). NO aparta el artículo.',
    recipient: 'Cliente',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre completo del cliente' },
      { token: '%customer_first_name%', label: 'Primer nombre del cliente' },
      { token: '%product_name%', label: 'Nombre del producto' },
      { token: '%message%', label: 'Mensaje adicional escrito por el staff al avisar' },
      { token: '%details_table%', label: 'Tabla con el producto' },
    ],
    defaults: {
      subject: '¡Ya está disponible: %product_name%! — B&B Target Center',
      title: '¡Ya está disponible!',
      intro: 'Hola %customer_first_name%, el producto por el que estabas en lista de espera ya llegó a B&B Target Center.',
      body: '<p>%details_table%</p><p>%message%</p><p><strong>Importante:</strong> este aviso no aparta ni reserva el artículo. Las unidades son limitadas y se venden por orden de llegada. Si lo quieres, llámanos al <strong>787-755-9060</strong> para pagarlo o pasa por la tienda lo antes posible.</p>',
      footerNote: 'Si ya no te interesa, puedes salir de la lista desde la app o en bbtc-dashboard.web.app/waitlist.',
    },
  },
  {
    key: 'transferRequestReceived',
    name: 'Transferencia FFL: solicitud recibida',
    description: 'Confirmación al cliente cuando envía una solicitud de transferencia FFL a FFL desde la web o la app (o cuando el staff reenvía el acuse desde la ficha).',
    recipient: 'Cliente',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre completo del cliente' },
      { token: '%customer_first_name%', label: 'Primer nombre del cliente' },
      { token: '%code%', label: 'Referencia (T-XXXXXX)' },
      { token: '%direction%', label: 'Tipo (B&B envía / recibe …)' },
      { token: '%firearms%', label: 'Arma(s)' },
      { token: '%dealer_name%', label: 'Armería FFL' },
      { token: '%fee%', label: 'Costo del servicio' },
      { token: '%carrier%', label: 'Carrier (USPS, FedEx…)' },
      { token: '%tracking_number%', label: 'Número de tracking' },
      { token: '%message%', label: 'Mensaje adicional escrito por el staff' },
      { token: '%status_badge%', label: 'Insignia de estado' },
      { token: '%details_table%', label: 'Tabla con el detalle' },
      { token: '%signature_name%', label: 'Nombre con el que firmó' },
      { token: '%signed_date%', label: 'Fecha de la firma' },
    ],
    defaults: {
      subject: 'Recibimos tu solicitud de transferencia %code% — B&B Target Center',
      title: 'Recibimos tu solicitud de transferencia',
      intro: 'Hola %customer_first_name%, recibimos tu solicitud de transferencia de arma de fuego (FFL a FFL). Nuestro personal la revisará y te contactará para los próximos pasos.',
      body: '<p>%status_badge%</p><p>%details_table%</p><p>Costo del servicio según el contrato: $125.00 por arma corta, $150.00 por rifle o escopeta, o el 10% del valor del arma si es mayor. El envío y el seguro los paga el cliente a la armería que envía.</p><p>Aceptaste los términos firmando como <strong>%signature_name%</strong> el %signed_date%.</p>',
      footerNote: 'Tel. 787-755-9060 · bbtargetcenter@gmail.com',
    },
  },
  {
    key: 'transferShipped',
    name: 'Transferencia FFL: arma enviada (tracking)',
    description: 'Se envía al cliente cuando el staff marca la transferencia como enviada y escribe el número de tracking.',
    recipient: 'Cliente',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre completo del cliente' },
      { token: '%customer_first_name%', label: 'Primer nombre del cliente' },
      { token: '%code%', label: 'Referencia (T-XXXXXX)' },
      { token: '%direction%', label: 'Tipo (B&B envía / recibe …)' },
      { token: '%firearms%', label: 'Arma(s)' },
      { token: '%dealer_name%', label: 'Armería FFL' },
      { token: '%fee%', label: 'Costo del servicio' },
      { token: '%carrier%', label: 'Carrier (USPS, FedEx…)' },
      { token: '%tracking_number%', label: 'Número de tracking' },
      { token: '%message%', label: 'Mensaje adicional escrito por el staff' },
      { token: '%status_badge%', label: 'Insignia de estado' },
      { token: '%details_table%', label: 'Tabla con el detalle' },
    ],
    defaults: {
      subject: 'Tu arma fue enviada · tracking %tracking_number% — B&B Target Center',
      title: 'Tu paquete fue enviado',
      intro: 'Hola %customer_first_name%, tu arma ya fue enviada a %dealer_name%.',
      body: '<p>%details_table%</p><p>%message%</p>',
      footerNote: 'Tel. 787-755-9060 · bbtargetcenter@gmail.com',
    },
  },
  {
    key: 'transferReceived',
    name: 'Transferencia FFL: arma recibida (lista para recoger)',
    description: 'Se envía al cliente cuando el staff marca que el arma llegó a B&B y está lista para recoger.',
    recipient: 'Cliente',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre completo del cliente' },
      { token: '%customer_first_name%', label: 'Primer nombre del cliente' },
      { token: '%code%', label: 'Referencia (T-XXXXXX)' },
      { token: '%direction%', label: 'Tipo (B&B envía / recibe …)' },
      { token: '%firearms%', label: 'Arma(s)' },
      { token: '%dealer_name%', label: 'Armería FFL' },
      { token: '%fee%', label: 'Costo del servicio' },
      { token: '%carrier%', label: 'Carrier (USPS, FedEx…)' },
      { token: '%tracking_number%', label: 'Número de tracking' },
      { token: '%message%', label: 'Mensaje adicional escrito por el staff' },
      { token: '%status_badge%', label: 'Insignia de estado' },
      { token: '%details_table%', label: 'Tabla con el detalle' },
    ],
    defaults: {
      subject: 'Tu arma llegó a B&B Target Center · %code%',
      title: 'Tu arma llegó',
      intro: 'Hola %customer_first_name%, recibimos tu arma de fuego enviada por %dealer_name%. Ya puedes pasar por la tienda con tu licencia de armas para completar el trámite y recogerla.',
      body: '<p>%status_badge%</p><p>%details_table%</p><p>%message%</p><p>Según el contrato, pasados 120 días sin recogerla el arma se pone a la venta.</p>',
      footerNote: 'Tel. 787-755-9060 · bbtargetcenter@gmail.com',
    },
  },
  {
    key: 'serviceOrderArrived',
    name: 'Pedido especial: llegó (listo para recoger)',
    description: 'Se envía al cliente cuando el staff marca que un pedido especial llegó a la tienda.',
    recipient: 'Cliente',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre completo del cliente' },
      { token: '%customer_first_name%', label: 'Primer nombre del cliente' },
      { token: '%code%', label: 'Referencia' },
      { token: '%items%', label: 'Artículos / arma' },
      { token: '%balance%', label: 'Balance pendiente' },
      { token: '%service_type%', label: 'Tipo (pedido especial / limpieza / reparación)' },
      { token: '%message%', label: 'Mensaje adicional escrito por el staff' },
      { token: '%status_badge%', label: 'Insignia LISTO PARA RECOGER' },
      { token: '%details_table%', label: 'Tabla con el detalle' },
    ],
    defaults: {
      subject: '¡Llegó tu pedido especial %code%! — B&B Target Center',
      title: 'Tu pedido llegó',
      intro: 'Hola %customer_first_name%, tu pedido especial ya llegó a B&B Target Center. Pasa por la tienda a recogerlo.',
      body: '<p>%status_badge%</p><p>%details_table%</p><p>%message%</p><p>Según el contrato de pedidos especiales, tienes 30 días calendario para recogerlo. Pasado ese término, el artículo se pone a la venta sin devolución de dinero.</p>',
      footerNote: 'Tel. 787-755-9060 · bbtargetcenter@gmail.com',
    },
  },
  {
    key: 'serviceReady',
    name: 'Limpieza / reparación: lista para recoger',
    description: 'Se envía al cliente cuando el staff marca que la limpieza o reparación de su arma está terminada.',
    recipient: 'Cliente',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre completo del cliente' },
      { token: '%customer_first_name%', label: 'Primer nombre del cliente' },
      { token: '%code%', label: 'Referencia' },
      { token: '%items%', label: 'Artículos / arma' },
      { token: '%balance%', label: 'Balance pendiente' },
      { token: '%service_type%', label: 'Tipo (pedido especial / limpieza / reparación)' },
      { token: '%message%', label: 'Mensaje adicional escrito por el staff' },
      { token: '%status_badge%', label: 'Insignia LISTO PARA RECOGER' },
      { token: '%details_table%', label: 'Tabla con el detalle' },
    ],
    defaults: {
      subject: 'Tu %service_type% está lista · %code% — B&B Target Center',
      title: 'Tu %service_type% está lista',
      intro: 'Hola %customer_first_name%, ya terminamos la %service_type% de tu arma. Puedes pasar por la tienda con tu licencia a recogerla.',
      body: '<p>%status_badge%</p><p>%details_table%</p><p>%message%</p>',
      footerNote: 'Tel. 787-755-9060 · bbtargetcenter@gmail.com',
    },
  },
  {
    key: 'reservationConfirmation',
    name: 'Confirmación de reservación (Campo de Tiro)',
    description: 'Se envía al cliente cuando su reservación del campo de tiro queda confirmada. Los cursos usan su propia plantilla.',
    recipient: 'Cliente',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre completo del cliente' },
      { token: '%customer_first_name%', label: 'Primer nombre del cliente' },
      { token: '%category_name%', label: 'Categoría o curso' },
      { token: '%date%', label: 'Fecha de la reservación' },
      { token: '%start_time%', label: 'Hora de inicio' },
      { token: '%end_time%', label: 'Hora de fin' },
      { token: '%lane_name%', label: 'Nombre del lane' },
      { token: '%confirmation_code%', label: 'Código de confirmación' },
      { token: '%amount%', label: 'Monto pagado' },
      { token: '%status_badge%', label: 'Insignia de estado (CONFIRMADA)' },
      { token: '%details_table%', label: 'Tabla con los detalles' },
      { token: '%deposit_banner%', label: 'Aviso de balance pendiente (si aplica)' },
      { token: '%info_box%', label: 'Recordatorio de llegada' },
    ],
    defaults: {
      subject: '✓ Reserva confirmada: %category_name% — %date%',
      title: '¡Reserva confirmada!',
      intro: 'Hola %customer_first_name%, tu reservación fue confirmada. Aquí están los detalles.',
      body: '<p>%status_badge%</p><p>%details_table%</p><p>%deposit_banner%</p><p>%info_box%</p>',
      footerNote: 'Guarda este correo como comprobante. Te esperamos pronto.',
    },
  },
  {
    key: 'reservationConfirmationCourse',
    name: 'Confirmación de inscripción (Cursos)',
    description: 'Se envía al cliente cuando su inscripción a un curso queda confirmada. Independiente de la del campo de tiro.',
    recipient: 'Cliente',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre completo del cliente' },
      { token: '%customer_first_name%', label: 'Primer nombre del cliente' },
      { token: '%category_name%', label: 'Nombre del curso' },
      { token: '%date%', label: 'Fecha del curso' },
      { token: '%start_time%', label: 'Hora de inicio' },
      { token: '%end_time%', label: 'Hora de fin' },
      { token: '%lane_name%', label: 'Nombre del lane (vacío en cursos)' },
      { token: '%confirmation_code%', label: 'Código de confirmación' },
      { token: '%amount%', label: 'Monto pagado' },
      { token: '%status_badge%', label: 'Insignia de estado (CONFIRMADA)' },
      { token: '%details_table%', label: 'Tabla con los detalles' },
      { token: '%deposit_banner%', label: 'Aviso de balance pendiente (si aplica)' },
      { token: '%info_box%', label: 'Recordatorio de llegada' },
    ],
    defaults: {
      subject: '✓ Inscripción confirmada: %category_name%',
      title: '¡Inscripción confirmada!',
      intro: 'Hola %customer_first_name%, tu inscripción al curso fue confirmada. Aquí están los detalles.',
      body: '<p>%status_badge%</p><p>%details_table%</p><p>%deposit_banner%</p><p>%info_box%</p>',
      footerNote: 'Guarda este correo como comprobante. Te esperamos pronto.',
    },
  },
  {
    key: 'reservationPaymentLink',
    name: 'Link de pago (inscripción pendiente)',
    description: 'Se envía cuando el equipo inscribe al cliente (curso privado o curso regular) y la reservación queda pendiente hasta que pague por el link. También va por SMS.',
    recipient: 'Cliente',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre completo del cliente' },
      { token: '%customer_first_name%', label: 'Primer nombre del cliente' },
      { token: '%category_name%', label: 'Curso o categoría' },
      { token: '%date%', label: 'Fecha' },
      { token: '%start_time%', label: 'Hora de inicio' },
      { token: '%end_time%', label: 'Hora de fin' },
      { token: '%lane_name%', label: 'Lane (vacío en cursos)' },
      { token: '%confirmation_code%', label: 'Código de confirmación' },
      { token: '%amount%', label: 'Monto a pagar' },
      { token: '%payment_url%', label: 'Enlace de pago (texto)' },
      { token: '%pay_button%', label: 'Botón "Pagar"' },
      { token: '%status_badge%', label: 'Insignia PENDIENTE DE PAGO' },
      { token: '%details_table%', label: 'Tabla con los detalles' },
      { token: '%info_box%', label: 'Aviso de que el cupo se libera si no paga' },
    ],
    defaults: {
      subject: 'Pago pendiente: %category_name% — %date%',
      title: 'Completa tu inscripción',
      intro: 'Hola %customer_first_name%, el equipo de B&B te inscribió. Solo falta el pago para confirmar.',
      body: '<p>%status_badge%</p><p>%details_table%</p><p>%pay_button%</p><p>%info_box%</p><p>Si el botón no funciona, copia este enlace: %payment_url%</p>',
      footerNote: 'El pago es seguro y se procesa con Stripe. Recibirás la confirmación por email.',
    },
  },
  {
    key: 'reservationCancellation',
    name: 'Cancelación de reservación',
    description: 'Se envía al cliente cuando su reservación es cancelada (incluye reembolso si aplica).',
    recipient: 'Cliente',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre completo del cliente' },
      { token: '%customer_first_name%', label: 'Primer nombre del cliente' },
      { token: '%category_name%', label: 'Categoría' },
      { token: '%date%', label: 'Fecha de la reservación' },
      { token: '%start_time%', label: 'Hora de inicio' },
      { token: '%end_time%', label: 'Hora de fin' },
      { token: '%lane_name%', label: 'Nombre del lane' },
      { token: '%confirmation_code%', label: 'Código de confirmación' },
      { token: '%reason%', label: 'Motivo de cancelación' },
      { token: '%refund_amount%', label: 'Monto del reembolso' },
      { token: '%status_badge%', label: 'Insignia de estado (CANCELADA)' },
      { token: '%details_table%', label: 'Tabla con los detalles' },
      { token: '%refund_box%', label: 'Aviso de reembolso (si aplica)' },
    ],
    defaults: {
      subject: 'Reserva cancelada — %category_name%',
      title: 'Reserva cancelada',
      intro: 'Hola %customer_first_name%, tu reserva fue cancelada. Aquí están los detalles.',
      body: '<p>%status_badge%</p><p>%details_table%</p><p>%refund_box%</p><p>¿Quieres reservar otra fecha? Abre la app de B&B Target Center.</p>',
      footerNote: 'Si crees que esto es un error, contáctanos al correo de soporte.',
    },
  },
  {
    key: 'welcomeEmail',
    name: 'Bienvenida (cuenta nueva)',
    description: 'Se envía cuando se crea la cuenta de un nuevo miembro.',
    recipient: 'Cliente',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre completo del cliente' },
      { token: '%customer_first_name%', label: 'Primer nombre del cliente' },
      { token: '%details_table%', label: 'Tabla con los detalles de la cuenta' },
    ],
    defaults: {
      subject: '¡Bienvenido a B&B Target Center, %customer_first_name%!',
      title: '¡Bienvenido, %customer_first_name%!',
      intro: 'Gracias por unirte a B&B Target Center. Ya puedes reservar lanes, inscribirte a cursos y mucho más desde la app.',
      body: '<p>%details_table%</p><p>Para activar tu membresía y desbloquear precios de socio, visita el local o contacta al equipo.</p><h3>¿Qué puedes hacer ahora?</h3><ul><li>Reservar lanes y sesiones de tiro</li><li>Inscribirte a cursos disponibles</li><li>Guardar tu tarjeta de membresía digital</li><li>Ver tu historial y próximas reservaciones</li></ul>',
      footerNote: 'Si tienes dudas, escríbenos. Estamos para ayudarte.',
    },
  },
  {
    key: 'membershipPaymentReceived',
    name: 'Pago de membresía recibido',
    description: 'Se envía al cliente cuando su pago de membresía se procesa correctamente.',
    recipient: 'Cliente',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre completo del cliente' },
      { token: '%customer_first_name%', label: 'Primer nombre del cliente' },
      { token: '%plan_name%', label: 'Nombre del plan' },
      { token: '%amount%', label: 'Monto pagado' },
      { token: '%expiration_date%', label: 'Fecha de vencimiento' },
      { token: '%status_badge%', label: 'Insignia de estado (ACTIVA)' },
      { token: '%details_table%', label: 'Tabla con los detalles del pago' },
    ],
    defaults: {
      subject: 'Pago recibido — Membresía %plan_name%',
      title: '¡Pago recibido!',
      intro: 'Hola %customer_first_name%, recibimos tu pago. Tu membresía está activa.',
      body: '<p>%status_badge%</p><p>%details_table%</p><p>Tu tarjeta digital de socio ya está disponible en la app. Tócala para verla en formato grande.</p>',
      footerNote: 'Gracias por ser parte de B&B Target Center.',
    },
  },
  {
    key: 'paymentNotificationToStaff',
    name: 'Aviso de pago (staff)',
    description: 'Notificación interna al equipo cuando se recibe un pago en la app.',
    recipient: 'Staff',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre del cliente' },
      { token: '%customer_email%', label: 'Email del cliente' },
      { token: '%plan_name%', label: 'Nombre del plan' },
      { token: '%amount%', label: 'Monto pagado' },
      { token: '%payment_date%', label: 'Fecha del pago' },
      { token: '%details_table%', label: 'Tabla con los detalles del pago' },
    ],
    defaults: {
      subject: '💰 Nuevo pago recibido — %amount%',
      title: 'Nuevo pago de membresía',
      intro: 'Se recibió un pago en la app. Revisa los detalles abajo.',
      body: '<p>%details_table%</p>',
      footerNote: 'Notificación interna. No reenviar al cliente.',
    },
  },
  {
    key: 'licenseExpirationReminder',
    name: 'Licencia de armas por vencer',
    description: 'Recordatorio automático al cliente cuando faltan 2 meses (60 días) para que venza su licencia de armas. Se envía una sola vez por ciclo, diariamente a las 9:00 AM.',
    recipient: 'Cliente',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre completo del cliente' },
      { token: '%customer_first_name%', label: 'Primer nombre del cliente' },
      { token: '%license_number%', label: 'Número de licencia' },
      { token: '%expiration_date%', label: 'Fecha de vencimiento' },
      { token: '%days_left%', label: 'Días restantes' },
      { token: '%status_badge%', label: 'Insignia de estado (POR VENCER)' },
      { token: '%details_table%', label: 'Tabla con los detalles' },
    ],
    defaults: {
      subject: '⚠️ Tu licencia de armas vence pronto — %expiration_date%',
      title: 'Tu licencia vence pronto',
      intro: 'Hola %customer_first_name%, tu licencia de armas vence el %expiration_date%. Renuévala a tiempo para seguir practicando sin interrupciones.',
      body: '<p>%status_badge%</p><p>%details_table%</p><p>¿Necesitas renovar tu licencia? En B&B Target Center te ayudamos con el proceso de renovación. Contáctanos o visítanos en el local.</p>',
      footerNote: 'Este es un recordatorio automático. Si ya renovaste tu licencia, actualiza la fecha en la app y puedes ignorar este correo.',
    },
  },
  {
    key: 'membershipExpirationReminder',
    name: 'Membresía por vencer',
    description: 'Recordatorio automático al cliente cuando faltan 2 meses (60 días) para que venza su membresía. Se envía una sola vez por ciclo, diariamente a las 9:00 AM.',
    recipient: 'Cliente',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre completo del cliente' },
      { token: '%customer_first_name%', label: 'Primer nombre del cliente' },
      { token: '%expiration_date%', label: 'Fecha de vencimiento' },
      { token: '%days_left%', label: 'Días restantes' },
      { token: '%status_badge%', label: 'Insignia de estado (POR VENCER)' },
      { token: '%details_table%', label: 'Tabla con los detalles' },
    ],
    defaults: {
      subject: 'Tu membresía vence pronto — %expiration_date%',
      title: 'Tu membresía vence pronto',
      intro: 'Hola %customer_first_name%, tu membresía de B&B Target Center vence el %expiration_date%. Renuévala para no perder tus beneficios de socio.',
      body: '<p>%status_badge%</p><p>%details_table%</p><p>Renueva desde la app o visítanos en el local. Como socio mantienes precios especiales, reservaciones prioritarias y tu tarjeta digital.</p>',
      footerNote: 'Este es un recordatorio automático. Si ya renovaste, puedes ignorar este correo.',
    },
  },
  {
    key: 'membershipRequestApproved',
    name: 'Solicitud de membresía aprobada',
    description: 'Se envía al cliente cuando su solicitud de membresía con evidencia (tarifa especial) es aprobada y se le cobra la tarjeta.',
    recipient: 'Cliente',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre completo del cliente' },
      { token: '%customer_first_name%', label: 'Primer nombre del cliente' },
      { token: '%plan_name%', label: 'Nombre del plan' },
      { token: '%amount%', label: 'Monto cobrado' },
      { token: '%expiration_date%', label: 'Fecha de vencimiento' },
      { token: '%status_badge%', label: 'Insignia de estado (ACTIVA)' },
      { token: '%details_table%', label: 'Tabla con los detalles' },
    ],
    defaults: {
      subject: '¡Solicitud aprobada! — Membresía %plan_name%',
      title: '¡Solicitud aprobada!',
      intro: 'Hola %customer_first_name%, revisamos tu evidencia y tu solicitud fue aprobada. Cobramos tu tarjeta y tu membresía ya está activa.',
      body: '<p>%status_badge%</p><p>%details_table%</p><p>Tu tarjeta digital de socio ya está disponible en la app.</p>',
      footerNote: 'Gracias por ser parte de B&B Target Center.',
    },
  },
  {
    key: 'membershipRequestRejected',
    name: 'Solicitud de membresía rechazada',
    description: 'Se envía al cliente cuando su solicitud de membresía con evidencia no es aprobada. No se le cobra nada.',
    recipient: 'Cliente',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre completo del cliente' },
      { token: '%customer_first_name%', label: 'Primer nombre del cliente' },
      { token: '%plan_name%', label: 'Nombre del plan' },
      { token: '%reason%', label: 'Razón del rechazo' },
      { token: '%status_badge%', label: 'Insignia de estado (NO APROBADA)' },
      { token: '%details_table%', label: 'Tabla con la razón' },
    ],
    defaults: {
      subject: 'Sobre tu solicitud de membresía %plan_name%',
      title: 'Solicitud no aprobada',
      intro: 'Hola %customer_first_name%, revisamos tu solicitud para la membresía %plan_name% y no pudimos aprobarla en esta ocasión. No se hizo ningún cobro a tu tarjeta.',
      body: '<p>%status_badge%</p><p>%details_table%</p><p>Si crees que es un error o quieres enviar otra evidencia, contáctanos o visítanos en el local. También puedes volver a enviar la solicitud desde la tienda.</p>',
      footerNote: 'Estamos para ayudarte con cualquier duda.',
    },
  },
  {
    key: 'membershipRequestToStaff',
    name: 'Nueva solicitud de membresía (staff)',
    description: 'Notificación interna al equipo cuando un cliente envía una solicitud de membresía con evidencia desde la tienda.',
    recipient: 'Staff',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre del cliente' },
      { token: '%customer_phone%', label: 'Teléfono del cliente' },
      { token: '%customer_email%', label: 'Email del cliente' },
      { token: '%plan_name%', label: 'Nombre del plan' },
      { token: '%amount%', label: 'Monto (se cobra al aprobar)' },
      { token: '%details_table%', label: 'Tabla con los detalles' },
    ],
    defaults: {
      subject: '📋 Nueva solicitud de membresía — %customer_name% (%plan_name%)',
      title: 'Nueva solicitud de membresía',
      intro: 'Un cliente envió una solicitud de membresía con tarifa especial. Revisa la evidencia y apruébala o recházala en el dashboard (Membresías → Solicitudes).',
      body: '<p>%details_table%</p>',
      footerNote: 'Notificación interna. Al aprobar se cobra la tarjeta guardada del cliente.',
    },
  },
  {
    key: 'layawayPaymentReceived',
    name: 'Layaway: pago recibido',
    description: 'Recibo al cliente por cada depósito, abono o pago de almacenaje de un layaway de arma (en tienda o desde la app).',
    recipient: 'Cliente',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre completo del cliente' },
      { token: '%customer_first_name%', label: 'Primer nombre del cliente' },
      { token: '%firearm%', label: 'Arma (marca, modelo, calibre)' },
      { token: '%serial_number%', label: 'Número de serie' },
      { token: '%concept%', label: 'Concepto (Depósito / Abono / Almacenaje)' },
      { token: '%amount%', label: 'Monto pagado (con IVU si aplica)' },
      { token: '%price%', label: 'Precio del arma' },
      { token: '%paid%', label: 'Pagado a la fecha' },
      { token: '%balance%', label: 'Balance pendiente' },
      { token: '%due_date%', label: 'Fecha límite' },
      { token: '%status_badge%', label: 'Insignia (ACTIVO / SALDADO)' },
      { token: '%details_table%', label: 'Tabla con el detalle' },
    ],
    defaults: {
      subject: 'Pago recibido — Layaway %firearm%',
      title: 'Pago recibido',
      intro: 'Hola %customer_first_name%, recibimos tu pago. Aquí está el estado de tu layaway.',
      body: '<p>%status_badge%</p><p>%details_table%</p><p>Puedes seguir abonando desde la app (Perfil → Mis Layaways). Si necesitas más tiempo, el almacenaje mensual extiende tu fecha límite.</p>',
      footerNote: 'Este correo es tu recibo. Guárdalo junto con tu contrato de layaway.',
    },
  },
  {
    key: 'layawayDueReminder',
    name: 'Layaway: vence pronto / vencido',
    description: 'Recordatorio automático unos días antes de la fecha límite del layaway y aviso cuando vence (aplica almacenaje mensual).',
    recipient: 'Cliente',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre completo del cliente' },
      { token: '%customer_first_name%', label: 'Primer nombre del cliente' },
      { token: '%firearm%', label: 'Arma' },
      { token: '%serial_number%', label: 'Número de serie' },
      { token: '%balance%', label: 'Balance pendiente' },
      { token: '%due_date%', label: 'Fecha límite' },
      { token: '%days_left%', label: 'Días restantes' },
      { token: '%storage_fee%', label: 'Tarifa de almacenaje mensual' },
      { token: '%status_badge%', label: 'Insignia (VENCE PRONTO / VENCIDO)' },
      { token: '%details_table%', label: 'Tabla con el detalle' },
    ],
    defaults: {
      subject: 'Tu layaway vence pronto — %due_date%',
      title: 'Tu layaway vence pronto',
      intro: 'Hola %customer_first_name%, te recordamos el estado de tu layaway en B&B Target Center.',
      body: '<p>%status_badge%</p><p>%details_table%</p><p>Puedes abonar o saldar desde la app (Perfil → Mis Layaways). Si necesitas más tiempo, cada mes de almacenaje (%storage_fee%) extiende la fecha límite 30 días.</p>',
      footerNote: 'Si ya pagaste, ignora este mensaje. Dudas: (787) 755-9060.',
    },
  },
  {
    key: 'layawayPaymentToStaff',
    name: 'Layaway: aviso de pago (staff)',
    description: 'Notificación interna cuando un cliente abona o paga almacenaje de su layaway desde la app o la web.',
    recipient: 'Staff',
    placeholders: [
      { token: '%customer_name%', label: 'Nombre del cliente' },
      { token: '%customer_phone%', label: 'Teléfono del cliente' },
      { token: '%customer_email%', label: 'Email del cliente' },
      { token: '%firearm%', label: 'Arma' },
      { token: '%serial_number%', label: 'Número de serie' },
      { token: '%concept%', label: 'Concepto' },
      { token: '%amount%', label: 'Monto pagado' },
      { token: '%balance%', label: 'Balance pendiente' },
      { token: '%due_date%', label: 'Fecha límite' },
      { token: '%details_table%', label: 'Tabla con el detalle' },
    ],
    defaults: {
      subject: '💰 Pago de layaway en la app — %customer_name% %amount%',
      title: 'Pago de layaway recibido',
      intro: 'Un cliente pagó su layaway desde la app/web. Detalles:',
      body: '<p>%details_table%</p>',
      footerNote: 'Notificación interna. No reenviar al cliente.',
    },
  },
];

function applyPlaceholders(str, map) {
  if (!str) return '';
  return Object.keys(map).reduce(
    (acc, token) => acc.split(token).join(map[token] == null ? '' : String(map[token])),
    str
  );
}

// Renderiza la vista previa (con datos de ejemplo) para el iframe del dialog.
export function renderPreviewHtml(templateKey, { title, intro, body, footerNote }) {
  const map = SAMPLE_VALUES[templateKey] || {};
  return layout({
    title: applyPlaceholders(title, map) || 'B&B Target Center',
    intro: applyPlaceholders(intro, map),
    contentHtml: applyPlaceholders(body, map),
    footerNote: applyPlaceholders(footerNote, map),
  });
}

export function applySamplePlaceholders(templateKey, str) {
  return applyPlaceholders(str, SAMPLE_VALUES[templateKey] || {});
}
